import { useAuth } from 'react-oidc-context';

import { extractUserPidFromSub } from '@/features/auth/services/oidc';
import { logOnce } from '@/utils/logger';

const useUserPid = () => {
  const { isLoading, user } = useAuth();
  const pid = user?.profile.sub ? extractUserPidFromSub(user.profile.sub) : undefined;
  if (pid && import.meta.env.MODE !== 'test') logOnce('useUserPid', 'User PID:', pid);

  return { isLoading, pid };
};

export default useUserPid;
